<template>
  <div>
    <v-toolbar flat :dark="contrastMode">
      <v-toolbar-side-icon
        class="hidden-md-and-up"
        @click.stop="drawer = !drawer"
        :aria-label="$t('TOP_BAR.BUTTON.DRAWER_OPEN')"
      ></v-toolbar-side-icon>

      <v-toolbar-items>
        <v-btn :ripple="false" :to="{ name: 'pageWrap' }" flat active-class>
          <img src="../assets/logo.png" class="logo-image" />
          <h2 class="toolbar-title">Wielozmysły</h2>
        </v-btn>
      </v-toolbar-items>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down toolbar-content">
        <v-btn
          v-for="item in menuItems"
          v-bind:key="item.id"
          :ripple="false"
          :to="{ name: 'pageWrap', params: { locale: $route.params.lang, pageSlug: item.slug } }"
          flat
        >{{item.title}}</v-btn>

        <!-- <v-divider vertical></v-divider> -->
        <div class="divider" v-bind:class="{contrastMode}" />

        <!-- language switch -->
        <!-- <language-switch /> -->
        <!-- contrast switch -->
        <contrast-switch :onContrastChange="onContrastChange" />
        <!-- font switch -->
        <font-size-switch v-bind:fontSize="fontSize" :onFontSizeChange="onFontSizeChange" />
      </v-toolbar-items>
    </v-toolbar>
    <!-- drawer -->
    <v-navigation-drawer v-model="drawer" absolute temporary :dark="contrastMode">
      <v-list dense>
        <v-list-tile>
          <v-list-tile-content>
            <v-btn :ripple="false" :to="{ name: 'pageWrap' }" flat active-class>
              <h2 class="toolbar-title">Wielozmysły</h2>
            </v-btn>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-for="item in menuItems" :key="item.id">
          <!-- <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>-->

          <v-list-tile-content>
            <v-btn
              :ripple="false"
              :to="{ name: 'pageWrap', params: { locale: $route.params.lang, pageSlug: item.slug } }"
              flat
            >{{item.title}}</v-btn>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>
        <!-- language switch -->
        <!-- <v-list-tile>
          <v-list-tile-content>
            <language-switch />
          </v-list-tile-content>
        </v-list-tile> -->
        <!-- contrast switch -->
        <v-list-tile>
          <v-list-tile-content>
            <contrast-switch :onContrastChange="onContrastChange" />
          </v-list-tile-content>
        </v-list-tile>
        <!-- font switch -->
        <v-list-tile>
          <v-list-tile-content>
            <font-size-switch v-bind:fontSize="fontSize" :onFontSizeChange="onFontSizeChange" />
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import LanguageSwitch from "./LanguageSwitch.vue";
import ContrastSwitch from "./ContrastSwitch.vue";
import FontSizeSwitch from "./FontSizeSwitch.vue";
import { SUPPORTED_LANGUAGES } from "../i18n/i18n";

export default {
  name: "TopBar",
  props: {
    contrastMode: Boolean,
    fontSize: String,
    onContrastChange: Function,
    onFontSizeChange: Function
  },
  data: () => {
    return {
      menuItems: Object,
      drawer: null
    };
  },
  components: { LanguageSwitch, ContrastSwitch, FontSizeSwitch },
  created() {
    const params = {};
    if (this.$route.params.lang !== SUPPORTED_LANGUAGES[0]) {
      params.lang = this.$route.params.lang;
    }
    this.$http.get("/custom/menu", { params }).then(response => {
      if (response && response.data) {
        this.menuItems = response.data.map(m => {
          return { id: m.ID, title: m.post_title, slug: m.post_name };
        });
        // console.log("TOPBAR.menu_items", this.menuItems, response.data);
      }
    });
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_global";

.toolbar-content {
  .v-btn--active:before,
  .v-btn:focus:before {
    background-color: transparent !important;
    border-bottom: 5px solid $accentColor;
    opacity: 1 !important;
  }

  .theme--dark.v-btn--active:before,
  .theme--dark.v-btn:focus:before {
    background-color: transparent !important;
    border-bottom: 5px solid $darkTextColor;
    opacity: 1 !important;
  }
}

.v-navigation-drawer {
  .v-btn {
    width: 100% !important;
    margin: 0;
  }
  .v-divider {
    margin: 10px;
  }
}

.divider {
  width: 1px;
  background-color: $accentColor;
  /* height: 100%; */
  margin: 20px;
}

.divider.contrastMode {
  background-color: $darkTextColor;
}

.toolbar-title {
  text-transform: uppercase;
  font-size: 2.3rem !important;
  font-weight: 400 !important;
}

.logo-image {
  width: 34px;
  margin-right: 10px;
}
</style>
